<template>
    <center-container>
        <v-checkbox
            v-for="selection in question.selections"
            :key="selection.uuid"
            v-model="selections"
            :label="selection.title"
            :value="selection.uuid"
            dense
            hide-details
        ></v-checkbox>

        <skip-and-send-button
            @send="sendSelection"
            @skip="$emit('skip')"
            :disabled="selections.length == 0"
        ></skip-and-send-button>
    </center-container>
</template>

<script>
import CenterContainer from "./CenterContainer.vue"
import SkipAndSendButton from "./SkipAndSendButton.vue"

export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    components: {
        CenterContainer,
        SkipAndSendButton,
    },

    data: () => ({
        selections: []
    }),

    methods: {
        sendSelection() {
            this.$emit('input', this.selections)
        }
    }
}
</script>
